document.addEventListener('DOMContentLoaded', function() {
  
  var optionWraps = document.querySelectorAll('.product-option-wrap');
  console.log(optionWraps)
  // Add a click event listener to each element
  optionWraps.forEach(function(optionWrap) {
    optionWrap.addEventListener('click', function() {
      
        // Get the variant ID from the data attribute
        var variantId = this.getAttribute('data-variant-id');
        console.log("Clicekd " , variantId)

        // Construct the ID of the radio input
        var radioId = 'product_variant_' + variantId;
        console.log("Checking " , radioId)

        // Get the radio input and set it to checked
        document.getElementById(radioId).checked = true;

        document.getElementById('productSelect').value = variantId
    });
});
  
  var variantImages = window.variantImages || {};

  document.getElementById('productSelect').addEventListener('change', function() {
    var selectedVariantId = this.value;
    var newImageUrl = variantImages[selectedVariantId];
    if (newImageUrl) {
      document.getElementById('productImage').src = newImageUrl;
    }
  });

  var productImages = document.querySelectorAll('.product-image');

  productImages.forEach(function(productImage) {
    productImage.addEventListener('click', function() {
      
        // Get the variant ID from the data attribute
        var selectedImageSrc = this.getAttribute('data-image-src');
        console.log("Clicekd " , selectedImageSrc)

        // Construct the ID of the radio input
       

        document.getElementById('productImage').src = selectedImageSrc
    });
});


});